const normalize = (email: string | null | undefined): string =>
  (email ?? '').trim().toLowerCase();

export function collectRecipientsForTopic(
  comments: Array<{ topic?: string; author_email?: string | null }>,
  topic: string,
  candidateEmail: string | null | undefined,
  selfEmail: string | null | undefined
): string[] {
  const self = normalize(selfEmail);
  const map = new Map<string, string>();

  const add = (email: string | null | undefined) => {
    if (!email) return;
    const key = normalize(email);
    if (!key || key === self) return;
    if (!map.has(key)) map.set(key, email);
  };

  add(candidateEmail);
  comments
    .filter((c) => (c.topic ?? 'general') === topic)
    .forEach((c) => add(c.author_email));

  return Array.from(map.values());
}

export function recipientsForNewTopic(
  candidateEmail: string | null | undefined,
  selfEmail: string | null | undefined
): string[] {
  const self = normalize(selfEmail);
  if (!candidateEmail) return [];
  if (normalize(candidateEmail) === self) return [];
  return [candidateEmail];
}
